/**
 * kult-pdp-b2b.js — Buybox der Firmenkunden-Ansicht der Kaffee-Produktseite (snippets/kult-pdp-b2b-buybox.liquid).
 * Custom Element <kult-pdp-b2b-buybox>. Kein Framework, keine externen Skripte.
 *
 * Ereignis-Vertrag
 *   Sendet (document):
 *     'kult:b2b:pdp-mode'  detail { mode: 'kauf'|'abo'|'etikett', handle, title, variantId, groesse, zubereitung }
 *                          beim Start (nach DOMContentLoaded), bei jedem Moduswechsel, bei jedem Variantenwechsel
 *                          und beim Klick auf „Anfrage senden“. groesse/zubereitung sind die gewählten Optionswerte ('' ohne Option).
 *     'kult:cart:add'      detail { cart, title } nach erfolgreichem POST /cart/add.js (öffnet den Drawer;
 *                          kult-b2b-shop.js setzt daraufhin das Warenkorb-Attribut Firmenbestellung).
 *   Steuert (document):    alle Elemente mit [data-b2b-inquiry]: Attribut hidden im Modus 'kauf', sonst entfernt.
 *   Liest:                 URL-Parameter ?modus=abo|etikett (Vorbelegung), ?variant= (Variante), ?view= bleibt erhalten.
 * Markup-Hooks (am Element): data-mode, data-handle, data-title, data-anchor, data-size-index, data-grind-index;
 *   innen [data-b2b-variants] (JSON), [data-variant-group] mit .kult-pdp-variant__pill, [data-mode-input],
 *   [data-price-net], [data-price-gross], [data-unit-net], [data-grind-hint], [data-buy-area], [data-inquiry-area],
 *   [data-mode-text], [data-inquiry-btn], [data-step], [data-qty-value] (input type=number, tippbar), [data-delivery-time]
 *   (data-default, data-bulk, data-bulk-from), [data-submit-btn], [data-form-error]; data-label-image für den Galerie-Wechsel.
 */
(function () {
  'use strict';
  if (customElements.get('kult-pdp-b2b-buybox')) return;

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function KultPdpB2bBuybox() { return Reflect.construct(HTMLElement, [], KultPdpB2bBuybox); }
  KultPdpB2bBuybox.prototype = Object.create(HTMLElement.prototype);
  KultPdpB2bBuybox.prototype.constructor = KultPdpB2bBuybox;
  Object.setPrototypeOf(KultPdpB2bBuybox, HTMLElement);

  KultPdpB2bBuybox.prototype.connectedCallback = function () {
    if (this._kultInit) return;
    this._kultInit = true;
    this.init();
  };

  KultPdpB2bBuybox.prototype.init = function () {
    var self = this;
    var dataEl = this.querySelector('[data-b2b-variants]');
    var data = { variants: [], current: null };
    try { data = JSON.parse(dataEl ? dataEl.textContent : '{}') || data; } catch (e) { /* leere Daten */ }
    this.variants = data.variants || [];
    this.sizeIdx = parseInt(this.getAttribute('data-size-index'), 10);
    this.grindIdx = parseInt(this.getAttribute('data-grind-index'), 10);
    this.qty = 1;
    this.current = null;
    var i;
    for (i = 0; i < this.variants.length; i++) {
      if (this.variants[i].id === data.current) this.current = this.variants[i];
    }
    if (!this.current) this.current = this.variants[0] || null;

    this.pills = Array.prototype.slice.call(this.querySelectorAll('.kult-pdp-variant__pill'));
    this.pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        self.selectOption(parseInt(pill.getAttribute('data-option-index'), 10), pill.getAttribute('data-option-value'));
      });
    });

    this.qtyValue = this.querySelector('[data-qty-value]');
    if (this.qtyValue && this.qtyValue.tagName === 'INPUT') {
      /* Zahl direkt eintippen (Okt. 2026): beim Tippen übernehmen, beim Verlassen auf 1–999 begrenzen und zurückschreiben */
      this.qtyValue.addEventListener('input', function () { var n = parseInt(self.qtyValue.value, 10); if (n > 0) self.setQty(n, true); });
      this.qtyValue.addEventListener('change', function () { self.setQty(parseInt(self.qtyValue.value, 10) || 1); });
      this.qtyValue.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); self.setQty(parseInt(self.qtyValue.value, 10) || 1); } });
    }
    this.deliveryEl = this.querySelector('[data-delivery-time]');
    Array.prototype.forEach.call(this.querySelectorAll('[data-step]'), function (btn) {
      btn.addEventListener('click', function () {
        self.setQty(self.qty + parseInt(btn.getAttribute('data-step'), 10));
      });
    });

    Array.prototype.forEach.call(this.querySelectorAll('[data-mode-input]'), function (input) {
      input.addEventListener('change', function () { if (input.checked) self.setMode(input.value, true); });
    });

    var submit = this.querySelector('[data-submit-btn]');
    if (submit) submit.addEventListener('click', function () { self.addToCart(); });

    /* Mobile Kaufleiste (Cowork Mo-23 U8, 12.10.2026), Verhalten wie assets/kult-pdp.js: an body hängen (Reveal-Transforms der
       Vorfahren würden position:fixed aushebeln), einblenden, sobald der Kauf-Button oben aus dem Bild gescrollt ist; nur im Modus „kauf“.
       Ab 960 px blendet kult-pdp.css die Leiste aus. */
    var bar = this.querySelector('[data-buybar]');
    if (bar && submit && 'IntersectionObserver' in window) {
      document.body.appendChild(bar);
      bar.hidden = false;
      bar.classList.add('is-hidden');
      this.buybar = bar;
      this.buybarPrice = bar.querySelector('[data-buybar-price]');
      this.buybarBtn = bar.querySelector('[data-buybar-btn]');
      this.buybarPast = false;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { self.buybarPast = e.boundingClientRect.top < 0 && !e.isIntersecting; });
        self.updateBuybar();
      }, { threshold: 0 }).observe(submit);
      if (this.buybarBtn) this.buybarBtn.addEventListener('click', function () { if (!submit.disabled) submit.click(); });
    }

    var inquiryBtn = this.querySelector('[data-inquiry-btn]');
    if (inquiryBtn) {
      inquiryBtn.addEventListener('click', function (e) {
        e.preventDefault();
        self.emitMode();
        self.scrollToInquiry();
      });
    }

    // Vorbelegung des Modus über ?modus=abo|etikett (nur, wenn die Option im Markup existiert)
    var mode = 'kauf';
    try {
      var wanted = new URL(window.location.href).searchParams.get('modus');
      if ((wanted === 'abo' || wanted === 'etikett') && this.querySelector('[data-mode-input][value="' + wanted + '"]')) mode = wanted;
    } catch (e2) { /* alte Browser */ }

    this.renderVariant(false);
    this.setMode(mode, false);
    var radio = this.querySelector('[data-mode-input][value="' + mode + '"]');
    if (radio) radio.checked = true;

    var first = function () { self.emitMode(); };
    if (document.readyState === 'complete') window.setTimeout(first, 0);
    else document.addEventListener('DOMContentLoaded', first, { once: true });
  };

  KultPdpB2bBuybox.prototype.find = function (opts) {
    var i, j, ok;
    for (i = 0; i < this.variants.length; i++) {
      ok = true;
      for (j = 0; j < opts.length; j++) { if (this.variants[i].options[j] !== opts[j]) ok = false; }
      if (ok) return this.variants[i];
    }
    return null;
  };

  /* Wahl einer Option: passende Variante suchen; gibt es die Kombination nicht, gilt die nächste Variante mit dem gewählten Wert. */
  KultPdpB2bBuybox.prototype.selectOption = function (index, value) {
    if (!this.current) return;
    var opts = this.current.options.slice();
    opts[index] = value;
    var hit = this.find(opts);
    if (!hit) {
      var pool = this.variants.filter(function (v) { return v.options[index] === value; });
      hit = pool.filter(function (v) { return v.available; })[0] || pool[0] || null;
    }
    if (!hit || hit === this.current) return;
    this.current = hit;
    this.renderVariant(true);
    this.emitMode();
  };

  KultPdpB2bBuybox.prototype.renderVariant = function (updateUrl) {
    var v = this.current;
    if (!v) return;
    var self = this;
    var net = this.querySelector('[data-price-net]');
    var gross = this.querySelector('[data-price-gross]');
    var unit = this.querySelector('[data-unit-net]');
    if (net) net.textContent = v.netMoney;
    if (gross) gross.textContent = v.grossMoney;
    if (unit) {
      unit.textContent = (v.unitNet || '').replace(/&nbsp;/g, ' ');
      unit.hidden = !v.unitNet;
    }

    this.pills.forEach(function (pill) {
      var idx = parseInt(pill.getAttribute('data-option-index'), 10);
      var val = pill.getAttribute('data-option-value');
      var active = v.options[idx] === val;
      pill.classList.toggle('is-active', active);
      pill.setAttribute('aria-pressed', active ? 'true' : 'false');
      // Kombination mit den übrigen gewählten Optionen: nicht vorhanden oder nicht lieferbar = deaktiviert dargestellt
      var opts = v.options.slice();
      opts[idx] = val;
      var combo = self.find(opts);
      pill.classList.toggle('is-disabled', !(combo && combo.available));
    });

    var hint = this.querySelector('[data-grind-hint]');
    if (hint && this.grindIdx > -1) {
      var grind = v.options[this.grindIdx] || '';
      var g = grind.toLowerCase();
      var bean = g.indexOf('bohne') > -1 || g.indexOf('sieb') > -1 || g.indexOf('vollautomat') > -1;
      hint.textContent = bean ? hint.getAttribute('data-hint-bean') : (hint.getAttribute('data-hint-grind') || '').replace('{zubereitung}', window.KultGrind ? window.KultGrind.label(grind) : grind);
    }

    var submit = this.querySelector('[data-submit-btn]');
    if (submit) {
      submit.disabled = !v.available;
      submit.textContent = v.available ? submit.getAttribute('data-label') : submit.getAttribute('data-soldout');
    }
    this.showError('');
    this.updateBuybar();

    if (updateUrl && window.history && window.history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', String(v.id));
        window.history.replaceState(null, '', url.toString());
      } catch (e) { /* ohne Adress-Update weiter */ }
    }
  };

  KultPdpB2bBuybox.prototype.updateBuybar = function () {
    if (!this.buybar) return;
    var submit = this.querySelector('[data-submit-btn]');
    var show = this.buybarPast && this.getAttribute('data-mode') === 'kauf';
    this.buybar.classList.toggle('is-hidden', !show);
    if (this.buybarPrice && this.current) this.buybarPrice.textContent = this.current.netMoney;
    if (this.buybarBtn && submit) {
      this.buybarBtn.textContent = submit.textContent;
      this.buybarBtn.disabled = submit.disabled;
    }
  };

  KultPdpB2bBuybox.prototype.setQty = function (n, typing) {
    this.qty = Math.max(1, Math.min(999, n));
    if (this.qtyValue && !typing) {
      if (this.qtyValue.tagName === 'INPUT') this.qtyValue.value = String(this.qty); else this.qtyValue.textContent = String(this.qty);
    }
    /* Lieferzeit: ab data-bulk-from Stück (Standard 21) die längere Lieferzeit, sonst die aus den Theme-Einstellungen */
    this.updateDelivery();
  };

  /* Lieferzeit: eigenes Etikett → data-label (voraussichtlich 14–20 Tage); sonst ab data-bulk-from Stück data-bulk, darunter data-default */
  KultPdpB2bBuybox.prototype.updateDelivery = function () {
    var d = this.deliveryEl;
    if (!d) return;
    var mode = this.getAttribute('data-mode');
    if (mode === 'etikett' && d.getAttribute('data-label')) { d.textContent = d.getAttribute('data-label'); return; }
    var from = parseInt(d.getAttribute('data-bulk-from'), 10) || 21;
    d.textContent = this.qty >= from ? (d.getAttribute('data-bulk') || d.getAttribute('data-default')) : d.getAttribute('data-default');
  };

  /* Modus „Mit eigenem Etikett“: Galerie zeigt das Tütenfoto ohne Kult-Logo (data-label-image), sonst das Produktfoto */
  KultPdpB2bBuybox.prototype.swapGallery = function (mode) {
    var src = this.getAttribute('data-label-image');
    if (!src) return;
    var img = document.querySelector('.kult-pdp-gallery__main img');
    if (!img) return;
    if (!img.dataset.kultOrigSrc) {
      img.dataset.kultOrigSrc = img.getAttribute('src') || '';
      img.dataset.kultOrigSrcset = img.getAttribute('srcset') || '';
      img.dataset.kultOrigAlt = img.getAttribute('alt') || '';
    }
    if (mode === 'etikett') {
      img.removeAttribute('srcset');
      img.setAttribute('src', src);
      img.setAttribute('alt', this.getAttribute('data-label-image-alt') || img.dataset.kultOrigAlt);
    } else {
      img.setAttribute('src', img.dataset.kultOrigSrc);
      if (img.dataset.kultOrigSrcset) img.setAttribute('srcset', img.dataset.kultOrigSrcset);
      img.setAttribute('alt', img.dataset.kultOrigAlt);
    }
  };

  KultPdpB2bBuybox.prototype.showError = function (text) {
    var el = this.querySelector('[data-form-error]');
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
  };

  KultPdpB2bBuybox.prototype.setMode = function (mode, emit) {
    this.setAttribute('data-mode', mode);
    var buy = this.querySelector('[data-buy-area]');
    var inquiry = this.querySelector('[data-inquiry-area]');
    if (buy) buy.hidden = mode !== 'kauf';
    if (inquiry) inquiry.hidden = mode === 'kauf';
    Array.prototype.forEach.call(this.querySelectorAll('[data-mode-text]'), function (p) {
      p.hidden = p.getAttribute('data-mode-text') !== mode;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-b2b-inquiry]'), function (el) {
      el.hidden = mode === 'kauf';
    });
    this.showError('');
    this.swapGallery(mode);
    this.updateDelivery();
    this.updateBuybar();
    if (emit) this.emitMode();
  };

  KultPdpB2bBuybox.prototype.emitMode = function () {
    var v = this.current;
    document.dispatchEvent(new CustomEvent('kult:b2b:pdp-mode', {
      detail: {
        mode: this.getAttribute('data-mode'),
        handle: this.getAttribute('data-handle'),
        title: this.getAttribute('data-title'),
        variantId: v ? v.id : null,
        groesse: v && this.sizeIdx > -1 ? v.options[this.sizeIdx] : '',
        zubereitung: v && this.grindIdx > -1 ? v.options[this.grindIdx] : ''
      }
    }));
  };

  KultPdpB2bBuybox.prototype.scrollToInquiry = function () {
    var id = this.getAttribute('data-anchor');
    var target = id ? document.getElementById(id) : null;
    if (!target) return;
    target.hidden = false;
    target.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
    var heading = target.matches('h1,h2,h3,h4') ? target : target.querySelector('h1,h2,h3,h4');
    var focusEl = heading || target;
    if (!focusEl.hasAttribute('tabindex')) focusEl.setAttribute('tabindex', '-1');
    try { focusEl.focus({ preventScroll: true }); } catch (e) { focusEl.focus(); }
    if (window.history && window.history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.hash = id;
        window.history.replaceState(null, '', url.toString());
      } catch (e2) { /* Hash optional */ }
    }
  };

  KultPdpB2bBuybox.prototype.addToCart = function () {
    var self = this;
    var v = this.current;
    var btn = this.querySelector('[data-submit-btn]');
    if (!v || !v.available || !btn || btn.getAttribute('aria-busy') === 'true') return;
    var fallback = (this.querySelector('[data-form-error]') || btn).getAttribute('data-fallback') || '';
    var title = this.getAttribute('data-title');
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    this.showError('');
    function done() {
      btn.removeAttribute('aria-busy');
      btn.disabled = !(self.current && self.current.available);
      self.updateBuybar();
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: this.qty, properties: { _kultb2b_quelle: 'shop' } }] })
    }).then(function (res) {
      return res.json().then(function (json) { return { ok: res.ok, json: json }; });
    }).then(function (r) {
      if (!r.ok) throw new Error(r.json && (r.json.description || r.json.message) || fallback);
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (c) { return c.json(); });
    }).then(function (cart) {
      document.dispatchEvent(new CustomEvent('kult:cart:add', { detail: { cart: cart, title: title } }));
      done();
    }).catch(function (err) {
      self.showError((err && err.message) || fallback);
      done();
    });
  };

  customElements.define('kult-pdp-b2b-buybox', KultPdpB2bBuybox);
})();
